import Banner from "components/common/Banner";

import Overlay from "./Overlay";
import OverlayMobile from "./OverlayMobile";

import envs from "config/envs";

const HomeBanner = () => {
  return (
    <section role="banner">
      <Banner
        background={`${envs.HOST_STATIC_CDN}/AreaAberta/Images/banner_home.webp`}
        width="100vw"
        height="45vw"
      >
        <Banner.Overlay center={false}>
          <Overlay />
        </Banner.Overlay>
      </Banner>

      <Banner
        mobileBackground={`${envs.HOST_STATIC_CDN}/AreaAberta/Images/banner_home_mobile.webp`}
        width="100vw"
        height="130vw"
        isMobile
      >
        <Banner.Overlay center={false} isMobile>
          <OverlayMobile />
        </Banner.Overlay>
      </Banner>
    </section>
  );
};
export default HomeBanner;
